import EsusView from 'components/esus/EsusView'

export default function ProcedimentosIndividualizadosView() {
  return <EsusView url='/pec/user/relatorios/producao/analiticoProcedimentosIndividualizados' />
}
